import {showNotification} from 'platform/components';

import {useCreateRecordAuditDefinitionMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {ApiError, useNavigate} from 'shared/web';

import {RecordAuditDefinitionForm} from '../../components/RecordAuditDefinitionForm';
import {toCreateRecordAuditDefinitionBody} from '../../utils/toRecordAuditDefinitionRequestBody';

export function Create() {
  const navigate = useNavigate();

  const [createRecordAuditDefinition, createRecordAuditDefinitionQuery] =
    useCreateRecordAuditDefinitionMutation();

  return (
    <RecordAuditDefinitionForm
      onSubmit={async (formData, setErrors, _reset, blockerContext) => {
        await createRecordAuditDefinition({
          body: toCreateRecordAuditDefinitionBody(formData),
        })
          .unwrap()
          .then(() => {
            showNotification.success(i18n.t('page.settings.generalChecklist.saveSuccess'));
            if (blockerContext?.wasSubmittedFromBlocker) {
              return;
            }
            navigate(settingsRoutes.recordAuditDefinition);
          })
          .catch((e: ApiError) =>
            handleApiError(e, {
              silentOnValidationError: true,
              setErrors,
              signalApiError: blockerContext?.reportApiFailure,
            })
          );
      }}
      isLoading={createRecordAuditDefinitionQuery.isLoading}
    />
  );
}
